// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/css';

const slider = document.querySelector('.section__blocks--reviews-slide');
// Initializing Swiper
if( slider ) {
    const swiper = new Swiper(slider, {
        slidesPerView: 3,
        initialSlide: 1,
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            100: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 100,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 150,
            },
        },
    });
}